import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

import ContextualMessage from '../components/contextualMessage';
import UserDisplay from '../components/userDisplay';

class ConfirmRecoveryCode extends Component {
    get labels() {
        return chainesLocales['ConfirmRecoveryCode'][this.props.lang];
    }

    render() {
        return (
            <form className="text-left">
                <h1>{this.labels.title}</h1>
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                <ContextualMessage type="success" showIcon={false} content={this.labels.msgPreEmail + '<br><br>' + this.props.user.useremail + '<br><br>' + this.labels.msgPostEmail} />
                <div className="row">
                    <div className="col">
                        <div>
                            <button className="btn btn-primary" type="submit" onClick={this.onContinuerClick.bind(this)}><span className="label">{this.labels.button}</span><span className="spinner"></span></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    onContinuerClick(e) {
        e.preventDefault();

        this.props.onPageSuccess({ confirmRC: { newPage: "demande-mot-passe" }});
    }
}

export default ConfirmRecoveryCode;